import React from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export function PromocionesDialog({ authAxios, onSuccess }) {
  const [showNew, setShowNew] = React.useState(false);
  const [form, setForm] = React.useState({
    name: "",
    description: "",
    discount_type: "percentage",
    discount_value: 0,
    applies_to: "all",
    starts_at: "",
    ends_at: ""
  });

  const create = async () => {
    if (!form.name) {
      toast.error("Nome obrigatório");
      return;
    }
    try {
      await authAxios.post("/marketing/promotions", form);
      toast.success("Promoção criada");
      setShowNew(false);
      setForm({
        name: "",
        description: "",
        discount_type: "percentage",
        discount_value: 0,
        applies_to: "all",
        starts_at: "",
        ends_at: ""
      });
      onSuccess();
    } catch {
      toast.error("Erro ao criar promoção");
    }
  };

  return (
    <div className="flex justify-end mb-4">
      <Dialog open={showNew} onOpenChange={setShowNew}>
        <DialogTrigger asChild>
          <Button size="lg" className="gap-2">
            <Plus className="w-4 h-4" />
            Nova Promoção
          </Button>
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Nova Promoção</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label>Nome</Label>
              <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="Black Friday" />
            </div>
            <div className="space-y-2">
              <Label>Descrição</Label>
              <Textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="20% em todos os produtos" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Tipo</Label>
                <Select value={form.discount_type} onValueChange={v => setForm({...form, discount_type: v})}>
                  <SelectTrigger><SelectValue /></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="percentage">Porcentagem</SelectItem>
                    <SelectItem value="fixed">Fixo</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-2">
                <Label>Valor</Label>
                <Input type="number" value={form.discount_value} onChange={e => setForm({...form, discount_value: Number(e.target.value)})} />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <Label>Início</Label>
                <Input type="date" value={form.starts_at} onChange={e => setForm({...form, starts_at: e.target.value})} />
              </div>
              <div className="space-y-2">
                <Label>Fim</Label>
                <Input type="date" value={form.ends_at} onChange={e => setForm({...form, ends_at: e.target.value})} />
              </div>
            </div>
          </div>
          <DialogFooter>
            <Button onClick={create} className="w-full" size="lg">Criar Promoção</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
